import { Component, Input, Output, EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class VaultConnectionService {
    public createComponent(template: string): any {
        @Component({ template })
        class VaultComponent {
            public isDisabled = false;
            public isHidden = false;
            public vaultConfig = {};

            @Output() public onEditLink = new EventEmitter();

            private dataValue: any;
            @Input()
            public set data(value) {
                this.dataValue = value;
            }
            public get data() {
                return this.dataValue;
            }
        }

        return VaultComponent;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/VaultConnectionService.service.ts